import axiosInstance from "../../setupAxios";
import { EventStreamContentType, fetchEventSource } from "@microsoft/fetch-event-source";
import { IWorksSearchResult } from "../types/IWorksSearchResult";
import { IWorksSearchQuery } from "../types/IWorksSearchQuery";
import { IArtist } from "../types/IArtist";
import { IContributorSearchQuery } from "../types/IContributorSearchQuery";
import { IContributorSearchResult } from "../types/IContributorSearchResult";
import { IArtistSearchQuery } from "../types/IArtistSearchQuery";
import { IAgreementSearchQuery } from "../types/IAgreementSearchQuery";
import { IAgreementSearchResult } from "../types/IAgreementSearchResult";
import { IIPsSearchQuery } from "../types/IIPsSearchQuery";
import { IIPsSearchResult } from "../types/IIPsSearchResult";
import { AVEpisode, AVProductionYear, AVSeasonCode, EMPTY_STRING_VALUE, TEXT_READONLY_IN_REPERTOIRE_INPUT } from "../Consts";
import { IProductSearchQuery } from "../types/IProductSearchQuery";
import { IProductSearchResult } from "../types/IProductSearchResult";
import { IVersionHistorySearchResult } from "../types/IVersionHistorySearchResult";
import { IProductVersionHistorySearchResult } from "../types/IProductVersionHistorySearchResult";
import { ISocIPVersionHistorySearchResult } from "../types/ISocIPVersionHistorySearchResult";
import { forEach } from "lodash";
import { IWorkflowSearchQuery } from "../types/IWorkflowSearchQuery";
import { IWorkflowSearchResult } from "../types/IWorkflowSearchResult";
import { IWorkflow } from "../types/IWorkflow";
import { IUsagePool } from "../types/usageTypes/IUsagePool";
import { IUsagePoolSearchQuery } from "../types/usageTypes/IUsagePoolSearchQuery";
import { IDistributionSearchQuery } from "../types/usageTypes/IDistributionSearchQuery";
import { IDistribution } from "../types/usageTypes/IDistribution";
import { IAgreementVersionHistorySearchResult } from "../types/IAgreementVersionHistorySearchResult";
import { IUsagePoolVersionHistorySearchResult } from "../types/usageTypes/IUsagePoolVersionHistorySearchResult";
import { IAdjustmentSearchQuery } from "../types/usageTypes/IAdjustmentSearchQuery";
import { IAdjustment } from "../types/usageTypes/IAdjustment";
import { IClaimSearchResult } from "../../repertoire/types/IClaimSearchResult";
import { IClaimSearchQuery } from "../../repertoire/types/IClaimSearchQuery";
import { ILookupDictionary } from "../../lookup/types/ILookupDictionary";
import { AGREEMENT_CATEGORY_LOOKUP } from "../../lookup/Consts";
import { IWorkflowReferenceKeyValue } from "../types/IWorkflowReferenceKeyValue";
import { DataSource } from "../types/DataSource";
import { IPaymentRunSearchQuery } from "../types/IPaymentRunSearchQuery";
import { IPaymentRun } from "../types/usageTypes/IPaymentRun";
import { IPaymentRunVersionHistorySearchResult } from "../types/usageTypes/IPaymentRunVersionHistorySearchResult";
import { IAdjustmentVersionHistorySearchResult } from "../types/usageTypes/IAdjustmentVersionHistorySearchResult";
import { IShoppingCart } from "../types/IShoppingCart";
import { IProductCore } from "../types/IProductCore";
import { IShoppingCartSearchQuery } from "../types/IShoppingCartSearchQuery";
import { ILicenseUserSearchQuery } from "../types/ILicenseUserSearchQuery";
import { ILicenseUserSearchResult } from "../types/ILicenseUserSearchResult";
import { IWorkSubjectSearchResult } from "../types/IWorkSubjectSearchResult";
import { duration } from "moment";
import { ISubjectsSearchQuery } from "../types/ISubjectsSearchQuery";
import { IIceDistCacheAdditionalInfo } from "../types/IIceDistCacheAdditionalInfo";
import { ITerritoryLineage } from "../types/ITerritoryLineage";
import { ILicenseUsage } from "../types/usageTypes/ILicenseUsage";
import { ILicenseUsageSearchQuery } from "../types/usageTypes/ILicenseUsageSearchQuery";
import { IVenueSearchQuery } from "../types/IVenueSearchQuery";
import { ICustomerVenue } from "../types/ISetListVenue";
import * as dayjs from 'dayjs';
import { IPaginatedSearchResult } from "../../redux/types/IPaginationSearchResult";
import { parse } from "path";
import { parseWorkflowsToSearchResult } from "../../util/workflowUtils";
import { IIceDistCacheAdditionalInfoRequest } from "../types/IIceDistCacheAdditionalInfoRequest";
import { IAgreementWork } from "../types/IAgreementWork";
import { IApplicableWorkSearchQuery } from "../types/IApplicableWorkSearchQuery";
import { ILicenseVenueSearchQuery } from "../types/ILicenseVenueSearchQuery";
import { ILicenseCustomerVenue } from "../types/ILicenseCustomerVenue";
import { IWork } from "../types/IWork";
import { IWorksFromPackageSearchQuery } from "../types/IWorksFromPackageSearchQuery";
import { ISocietyAffiliationRequest, ISocietyAffiliationResult } from "../types/ISocietyAffiliation";
import { IEphemerals } from "../../redux/types/IEphemerals";
import { IEphemeralExceptions } from "../../redux/types/IEphemeralExceptions";
import { IEphemeralAndEphemeralExceptions } from "../../redux/types/IEphemeralAndEphemeralExceptions";


export class SearchRequests {
    public static getWorks(
        searchQuery: IWorksSearchQuery
    ): Promise<IWorksSearchResult[]> {
        const {
            title,
            number,
            artist,
            writers,
            societyAccountNumber,
            dataSource,
            workBatchID,
            hasOpenWorkflow,
            workType,
            workGroupID,
            status,
            workSource,
            includeIsReplacedWorks
        } = searchQuery;

        return new Promise<IWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/works", {
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    contributor: {
                        value: writers,
                        type: 0
                    },
                    societyAccountNumber: {
                        value: societyAccountNumber,
                        type: 0
                    },
                    workBatchID: {
                        value: (isNaN(parseInt(workBatchID))) ? workBatchID : parseInt(workBatchID),
                        type: 2
                    },
                    dataSource: dataSource,
                    workType: {
                        value: workType,
                        type: 2
                    },
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                    workGroupID: {
                        value: workGroupID,
                        type: 0
                    },
                    workSource: {
                        value: workSource,
                        type: 2
                    },
                    status: {
                        value: status,
                        type: 2
                    },
                    includeIsReplacedWorks: includeIsReplacedWorks ? includeIsReplacedWorks : false
                })
                .then(response => {
                    const workSearchResultItems: IWorksSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IWorksSearchResult = {
                            title: [],
                            titleTypeCodes: [],
                            number: [],
                            isReplaced: data.isReplaced ? data.isReplaced : false,
                            writers: [],
                            publishers: [],
                            artists: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            dataSource: dataSource,
                            duration: data.duration,
                            workTerritorySpecificInfo: data.workTerritorySpecificInfo,
                            workStatus: []
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                                workSearchResultItem.titleTypeCodes.push(data.workNames[x].type)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                            if (data.workTerritorySpecificInfo && data.workTerritorySpecificInfo[x]) {
                                workSearchResultItem.workStatus.push(data.workTerritorySpecificInfo[x].workStatus)
                            }
                        }

                        if (data.contributors) {
                            for (let x = 0; x < data.contributors.length; x++) {
                                if (data.contributors[x].contributorType === 'Writer' && workSearchResultItem.writers.length < 3) {
                                    if (data.contributors[x].ipiNumber)
                                        workSearchResultItem.writers.push(data.contributors[x].fullName + ' (' + data.contributors[x].ipiNumber.toString().padStart(11, '0') + ')')
                                    else
                                        workSearchResultItem.writers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    if (data.contributors[x].ipiNumber)
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName + ' (' + data.contributors[x].ipiNumber.toString().padStart(11, '0') + ')')
                                    else
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getWorksByNumberList(
        workNumbers: string[],
        workNumberTypes: string[],
        dataSource: string
    ): Promise<IWorksSearchResult[]> {
        return new Promise<IWorksSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/worksByNumberList", {
                    workNumbers: workNumbers,
                    workNumberTypes: workNumberTypes,
                    dataSource: dataSource
                })
                .then(response => {
                    const workSearchResultItems: IWorksSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IWorksSearchResult = {
                            title: [],
                            number: [],
                            isReplaced: data.isReplaced ? data.isReplaced : false,
                            writers: [],
                            publishers: [],
                            artists: [],
                            compoundType: data.medleyType ? data.medleyType : '',
                            workID: response.data[x].workID,
                            dataSource: dataSource,
                            duration: data.duration
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.workNames[x]) {
                                workSearchResultItem.title.push(data.workNames[x].name)
                            }

                            if (data.workNumbers[x]) {
                                workSearchResultItem.number.push(data.workNumbers[x].number)
                            }

                            if (data.performers[x]) {
                                workSearchResultItem.artists.push(data.performers[x].fullName)
                            }
                        }

                        if (data.contributors) {
                            for (let x = 0; x < data.contributors.length; x++) {
                                if (data.contributors[x].contributorType === 'Writer' && workSearchResultItem.writers.length < 3) {
                                    if (data.contributors[x].ipiNumber)
                                        workSearchResultItem.writers.push(data.contributors[x].fullName + ' (' + data.contributors[x].ipiNumber.toString().padStart(11, '0') + ')')
                                    else
                                        workSearchResultItem.writers.push(data.contributors[x].fullName)
                                }
                                if (data.contributors[x].contributorType === 'Publisher' && workSearchResultItem.publishers.length < 3) {
                                    if (data.contributors[x].ipiNumber)
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName + ' (' + data.contributors[x].ipiNumber.toString().padStart(11, '0') + ')')
                                    else
                                        workSearchResultItem.publishers.push(data.contributors[x].fullName)
                                }
                            }
                        }

                        workSearchResultItems.push(workSearchResultItem);
                    }

                    resolve(workSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getSubjects(
        searchQuery: ISubjectsSearchQuery
    ): Promise<IWorkSubjectSearchResult[]> {
        const {
            subjectCode,
            description,
        } = searchQuery;

        return new Promise<IWorkSubjectSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/subjects", {
                    workSubject: subjectCode,
                    description: description,
                    pagination: null,
                })
                .then(response => {
                    const workSubjectResultItems: IWorkSubjectSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let workSearchResultItem: IWorkSubjectSearchResult = {
                            code: data.code,
                            description: data.description,
                        };

                        workSubjectResultItems.push(workSearchResultItem);
                    }

                    resolve(workSubjectResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getWork(dataSource: string, workID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/work/" + dataSource + '/' + workID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getWorkHistoryVersion(workID: number, versionNumber: number, mergedWork: boolean, dataSource: DataSource): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get(`/work/WorkHistory/${workID}/${versionNumber}/${mergedWork}/${dataSource}`)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getAgreement(dataSource: string, agreementID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/agreement/" + dataSource + "/" + agreementID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getIP(ipBaseNumber?: string, accountNumber?: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            if (ipBaseNumber != null) {
                axiosInstance
                    .get("/interestedParty/IPBaseNumber/" + ipBaseNumber)
                    .then(response => {
                        if (response.status === 200) {
                            const result = response.data;
                            resolve(result);
                        }
                        else {
                            throw response;
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            }
            else if (accountNumber != null) {
                axiosInstance
                    .get("/interestedParty/Account/" + accountNumber)
                    .then(response => {
                        if (response.status === 200) {
                            const result = response.data;
                            resolve(result);
                        }
                        else {
                            throw response;
                        }
                    })
                    .catch(err => {
                        reject(err);
                    });
            }
            else {
                reject(404);
            }
        });
    }

    public static getArtist(performerID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/performer/" + performerID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getProduct(dataSource: string, productCoreID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/product/" + dataSource + '/' + productCoreID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getProductVersionHistory(productCoreID: number): Promise<IProductVersionHistorySearchResult[]> {
        return new Promise<IProductVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/ProductHistory/" + productCoreID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    public static getProductHistoryVersion(productCoreID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/product/ProductHistory/" + productCoreID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };
    public static getSocIPVersionHistory(socIPID: number): Promise<ISocIPVersionHistorySearchResult[]> {
        return new Promise<ISocIPVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/SocIPHistory/" + socIPID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    public static getSocIPHistoryVersion(socIPID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/interestedParty/SocIPHistory/" + socIPID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };
    public static getAgreementVersionHistory(agreementID: number): Promise<IAgreementVersionHistorySearchResult[]> {
        return new Promise<IAgreementVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/AgreementHistory/" + agreementID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    public static getAgreementHistoryVersion(agreementID: number, versionNumber: number, dataSource: DataSource): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/agreement/AgreementHistory/" + agreementID + '/' + versionNumber + '/' + dataSource)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    };

    public static getArtists(
        artist: IArtistSearchQuery,
        dataSource: string
    ): Promise<IArtist[]> {
        return new Promise<IArtist[]>((resolve, reject) => {
            axiosInstance
                .post("/search/artists", {
                    fullName: { value: artist.fullName, type: 0 },
                    firstName: { value: artist.firstName, type: 0 },
                    lastName: { value: artist.lastName, type: 0 },
                    number: { value: artist.number, type: 0 },
                    type: { value: artist.type, type: 0 },
                    dataSource: dataSource
                })
                .then(response => {
                    const artistSearchResultItems: IArtist[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        const artistSearchResultItem: IArtist = {
                            fullName: data.fullName,
                            performerID: data.performerID,
                            firstName: data.firstName,
                            lastName: data.lastName,
                            type: data.type,
                            number: data.number,
                            workPerformerID: data.workPerformerID,
                            performerNumberID: data.performerNumberID ? data.performerNumberID : 0,
                            numberType: data.numberType,
                        };
                        artistSearchResultItems.push(artistSearchResultItem);
                    }
                    resolve(artistSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getVenues(
        venue: IVenueSearchQuery,
        dataSource: string
    ): Promise<ICustomerVenue[]> {
        return new Promise<ICustomerVenue[]>((resolve, reject) => {
            axiosInstance
                .post("/search/venueCustomer", {
                    code: venue.code,
                    name: venue.name,
                })
                .then(response => {
                    const venueSearchResultItems: ICustomerVenue[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        const venueSearchResultItem: ICustomerVenue = {
                            customerID: data.customerID,
                            code: data.code,
                            name: data.name,
                        };
                        venueSearchResultItems.push(venueSearchResultItem);
                    }
                    resolve(venueSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getLicenseVenues(
        licenseVenue: ILicenseVenueSearchQuery,
        dataSource: string
    ): Promise<ILicenseCustomerVenue[]> {
        return new Promise<ILicenseCustomerVenue[]>((resolve, reject) => {
            axiosInstance
                .post("/License/LicensingVenue", {
                    code: licenseVenue.code,
                    name: licenseVenue.name,
                })
                .then(response => {
                    const licenseVenueSearchResultItems: ILicenseCustomerVenue[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        const licenseVenueSearchResultItem: ILicenseCustomerVenue = {
                            customerID: data.customerID,
                            venueCode: data.code,
                            venueName: data.name,
                            region: data.region
                        };
                        licenseVenueSearchResultItems.push(licenseVenueSearchResultItem);
                    }
                    resolve(licenseVenueSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getContributors(
        searchQuery: IContributorSearchQuery
    ): Promise<IContributorSearchResult[]> {
        const {
            ipNumber,
            fullName,
            accountNumber,
            legalEntityType,
            isMembersPortal
        } = searchQuery;
        return new Promise<IContributorSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/contributors", {
                    ipiNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? ipNumber : null,
                        type: 0
                    },
                    ipBaseNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? "" : ipNumber,
                        type: 0
                    },
                    fullName: {
                        value: fullName,
                        type: 0
                    },
                    accountNumber: {
                        value: accountNumber,
                        type: 1
                    },
                    legalEntityType: {
                        value: legalEntityType,
                        type: 0
                    },
                    isMembersPortal
                })
                .then(response => {
                    const contributorSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const contributorSearchResultItem = {
                            accountNumber: response.data[x].accountNumber,
                            accountName: response.data[x].accountName,
                            type: response.data[x].type,
                            ipiNumber: response.data[x].ipiNumber,
                            ipName: response.data[x].fullName,
                            ipBaseNumber: response.data[x].ipBaseNumber,
                            societyAffiliation: response.data[x].societyAffiliation,
                            legalEntityType: response.data[x].legalEntityType,
                            birthDate: response.data[x].birthDate !== null ? response.data[x].birthDate.substring(0, 10) : null,
                            societyOfLicense: response.data[x].defaultSocietyOfLicense,
                            mechSocietyAffiliation: response.data[x].mechSocietyAffiliation,
                            perfSocietyAffiliation: response.data[x].perfSocietyAffiliation,
                            status: response.data[x].status
                        };

                        contributorSearchResultItems.push(contributorSearchResultItem);
                    }

                    resolve(contributorSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getAgreements(
        searchQuery: IAgreementSearchQuery,
        lookupValues: ILookupDictionary
    ): Promise<IAgreementSearchResult[]> {
        const {
            ipBaseNumber,
            ipNameNumber,
            ipName,
            type,
            agreementReference,
            agreementCategory,
            dataSource,
            setTypeGroup,
            searchType,
            agreementId,
            agreementBatchID
        } = searchQuery;
        return new Promise<IAgreementSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/Agreements", {
                    ipBaseNumber: ipBaseNumber,
                    ipNameNumber: parseInt(ipNameNumber),
                    ipName: ipName,
                    type: type,
                    agreementReference: agreementReference,
                    agreementCategory: agreementCategory,
                    setTypeGroup: setTypeGroup,
                    dataSource: dataSource,
                    pagination: null,
                    searchType: searchType,
                    agreementBatchID: agreementBatchID === "" ? null : agreementBatchID,
                    agreementID: agreementId === "" ? null : agreementId,
                })
                .then(response => {
                    const agreementSearchResultItems = [];
                    let lookup = lookupValues[AGREEMENT_CATEGORY_LOOKUP].lookups;

                    for (let x = 0; x < response.data.length; x++) {
                        const agreementSearchResultItem = {
                            ipNameNumber: response.data[x].ipNameNumber,
                            ipBaseNumber: response.data[x].ipBaseNumber,
                            ipName: response.data[x].ipName,
                            agreementType: (response.data[x].type == 1 ? 'General' : 'Specific'),
                            agreementReference: response.data[x].agreementReference,
                            agreementCategory: lookup.filter(l => l.code === response.data[x].agreementCategory).length > 0 ? lookup.filter(l => l.code === response.data[x].agreementCategory)[0].description : '',
                            region: response.data[x].setTypeGroup,
                            effectiveFrom: response.data[x].effectiveFrom,
                            effectiveTo: response.data[x].effectiveTo,
                            maintained: response.data[x].maintained,
                            source: response.data[x].source,
                            agreementID: response.data[x].agreementID,
                            dataSource: dataSource,
                            worldExcluding: response.data[x].worldExcluding
                        };

                        agreementSearchResultItems.push(agreementSearchResultItem);
                    }
                    resolve(agreementSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static getIPs(
        searchQuery: IIPsSearchQuery
    ): Promise<IIPsSearchResult[]> {
        const {
            ipNumber,
            fullName,
            accountNumber,
            interestedPartyType,
            count,
            skip
        } = searchQuery;
        return new Promise<IIPsSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/IPs", {
                    ipiNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? ipNumber : null,
                        type: 0
                    },
                    fullName: {
                        value: fullName,
                        type: 0
                    },
                    ipBaseNumber: {
                        value: ipNumber && !isNaN(Number(ipNumber)) ? "" : ipNumber,
                        type: 0
                    },
                    accountNumber: {
                        value: accountNumber,
                        type: 2
                    },
                    replacedAccounts: [{
                        fieldName: "ReplacedAccount",
                        filterFields: [{
                            fieldName: "Number",
                            values: {
                                value: accountNumber,
                                type: 3
                            }
                        }]
                    }],
                    interestedPartyType: interestedPartyType,
                    pagination: {
                        count: count,
                        skip: skip
                    }
                })
                .then(response => {
                    const ipSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const ipSearchResultItem = {
                            ipNameNumber: response.data[x].ipiNumber,
                            ipBaseNumber: response.data[x].ipBaseNumber,
                            ipName: response.data[x].fullName,
                            ipType: response.data[x].type,
                            accountNumber: response.data[x].accountNumber,
                            societyAffiliation: response.data[x].societyAffiliation,
                            legalEntityType: response.data[x].legalEntityType,
                            accountName: response.data[x].accountName,
                            birthDate: response.data[x].birthDate !== null ? response.data[x].birthDate.substring(0, 10) : null,
                            isLibraryPublisher: response.data[x].isLibraryPublisher !== null ? response.data[x].isLibraryPublisher : null
                        };

                        ipSearchResultItems.push(ipSearchResultItem);
                    }
                    resolve(ipSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static getWorkVersionHistory(workID: number, dataSource: DataSource): Promise<IVersionHistorySearchResult[]> {
        return new Promise<IVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/WorkHistory/" + workID + '/' + dataSource)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getBulkWorkArchives(workIDs: number[], dataSource: DataSource): Promise<IVersionHistorySearchResult[]> {
        return new Promise<IVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("Search/WorkArchives/" + dataSource, workIDs)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getProducts(
        searchQuery: IProductSearchQuery
    ): Promise<IProductSearchResult[]> {
        const {
            productIDs,
            productType,
            title,
            number,
            contributor,
            artist,
            productBatchID,
            dataSource,
            hasOpenWorkflow,
            recordCompany,
            productionCategory,
            productSource,
            status,
            source,
        } = searchQuery;

        return new Promise<IProductSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/Products", {
                    productIDs: {
                        values: productIDs.map(id => { return { value: id, type: 2 } })
                    },
                    type: {
                        value: productType,
                        type: 1
                    },
                    title: {
                        value: title,
                        type: 0
                    },
                    number: {
                        value: number,
                        type: 0
                    },
                    contributor: {
                        value: contributor,
                        type: 0
                    },
                    artist: {
                        value: artist,
                        type: 0
                    },
                    productBatchID: {
                        value: (isNaN(parseInt(productBatchID))) ? productBatchID : parseInt(productBatchID),
                        type: 2
                    },
                    hasOpenWorkflow: {
                        value: hasOpenWorkflow,
                        type: 2
                    },
                    dataSource: dataSource,
                    recordCompany: {
                        value: recordCompany,
                        type: 0
                    },
                    productionCategory: {
                        value: productionCategory,
                        type: 0
                    },
                    productSource: {
                        value: productSource ? productSource : source,
                        type: 2
                    },
                    status: {
                        value: status,
                        type: 2
                    }
                })
                .then(response => {
                    const productSearchResultItems: IProductSearchResult[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];
                        const season = data.productNumbers.filter((item) => item.productNumberType === AVSeasonCode).length > 0
                            ? data.productNumbers.filter((item) => item.productNumberType === AVSeasonCode)[0].number
                            : "NA";

                        const episode = data.productNumbers.filter((item) => item.productNumberType === AVEpisode).length > 0
                            ? data.productNumbers.filter((item) => item.productNumberType === AVEpisode)[0].number
                            : "NA";

                        const yearOfProduction = data.productNumbers.filter((item) => item.productNumberType === AVProductionYear).length > 0
                            ? data.productNumbers.filter((item) => item.productNumberType === AVProductionYear)[0].number
                            : "";


                        let productSearchResultItem: IProductSearchResult = {
                            productCoreID: data.productCoreID,
                            dataSource: dataSource,
                            type: data.productType,
                            id1: data.id1 ?? '',
                            id2: data.id2 ?? '',
                            number: [],
                            title: [],
                            episode: `${season}-${episode}`,
                            source: data.source,
                            artist: [],
                            contributor: [],
                            originOfRevision: data.originOfRevision ? data.originOfRevision : null,
                            productionType: data.productionType ?? '',
                            musicDuration: data.musicDuration ? [data.musicDuration] : [],
                            worksCount: data.worksCount ?? 0,
                            status: data.status ? data.status : null,
                            productionCategory: data.productAVWork ? data.productAVWork.type : '',
                            yearOfProduction: yearOfProduction,
                        }

                        for (let x = 0; x < 3; x++) {
                            if (data.productNames[x]) {
                                var type = data.productNames[x].productNameType
                                productSearchResultItem.title.push(data.productNames[x].name + " (" + type + ")")
                            }

                            if (data.productPerformers[x]) {
                                productSearchResultItem.artist.push(data.productPerformers[x].performerName)
                            }

                            if (data.productNumbers[x]) {
                                productSearchResultItem.number.push(data.productNumbers[x].number)
                            }

                            if (data.productContributors[x]) {
                                productSearchResultItem.contributor.push(data.productContributors[x].name)
                            }
                        }

                        productSearchResultItems.push(productSearchResultItem);
                    }
                    resolve(productSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static getConfigurationParameter(key: string, group: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Component/ConfigurationParameter/" + key + "/" + group)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getWorkflows(
        searchQuery: IWorkflowSearchQuery
    ): Promise<IPaginatedSearchResult<IWorkflowSearchResult>> {
        const {
            assignedTo,
            entityName,
            entityType,
            status,
            workflowType,
            referenceKeyValues,
            valueKey,
            valuesMax,
            valuesMin,
            fromDateCreated,
            toDateCreated,
            fromUsageDate,
            toUsageDate,
            productType,
            errorMessages,
            sortingOrder,
        } = searchQuery;
        return new Promise<IPaginatedSearchResult<IWorkflowSearchResult>>((resolve, reject) => {
            axiosInstance
                .post("/Search/Workflows", {
                    entityType: { type: 0, value: entityType },
                    status: { type: 2, value: status },
                    entityName: { type: 0, value: entityName },
                    workflowType: { type: 2, value: workflowType },
                    assignedTo: { type: 0, value: assignedTo },
                    pagination: null,
                    referenceKeyValues: this.mapReferenceKeyValues(referenceKeyValues),
                    valueKey: { type: 2, value: valueKey },
                    valuesMax: { type: 2, value: valuesMax },
                    valuesMin: { type: 2, value: valuesMin },
                    fromDateCreated: { type: 2, value: fromDateCreated },
                    toDateCreated: { type: 2, value: toDateCreated },
                    fromUsageDate: { type: 2, value: fromUsageDate },
                    toUsageDate: { type: 2, value: toUsageDate },
                    productType: { type: 2, value: productType },
                    errorMessages: { type: 0, value: errorMessages },
                    sortingOrder: sortingOrder
                })
                .then(response => {
                    const workflowSearchResultItems = parseWorkflowsToSearchResult(response.data.results);
                    resolve({ results: workflowSearchResultItems, total: response.data.total });
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    static mapReferenceKeyValues = (referenceKeyValues: IWorkflowReferenceKeyValue[]) => {
        return referenceKeyValues.map((item) => ({ referenceKey: { type: 2, value: item.referenceKey }, referenceValue: { type: 2, value: item.referenceValue } }));
    }

    public static getUsagePools(searchQuery: IUsagePoolSearchQuery): Promise<IUsagePool[]> {
        const {
            poolCode,
            cat1,
            cat2,
            allocationRule,
            pagination
        } = searchQuery;
        return new Promise<IUsagePool[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/UsagePools", {
                    poolCode: poolCode,
                    cat1: cat1,
                    cat2: cat2,
                    allocationRule: allocationRule,
                    pagination: pagination
                })
                .then(response => {
                    const usagePoolSearchResultItems: IUsagePool[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];
                        const usagePoolSearchResultItem: IUsagePool = {
                            poolCode: data.poolCode,
                            description: data.description,
                            cat1: data.cat1,
                            cat2: data.cat2,
                            allocationRule: data.allocationRule,
                            invoice: data.invoice ? 'Yes' : 'No',
                            licenseeID: data.licenseeID,
                            poolId: data.poolID,
                            sources: [],
                            rights: data.rights,
                            poolCategory: data.poolCategory
                        };
                        usagePoolSearchResultItems.push(usagePoolSearchResultItem);
                    }
                    resolve(usagePoolSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                })
        });
    }

    public static getUsagePool(poolId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/usagePool/" + poolId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getPoolVersionHistory(poolID: number): Promise<IUsagePoolVersionHistorySearchResult[]> {
        return new Promise<IUsagePoolVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/PoolHistory/" + poolID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getPoolHistoryVersion(poolID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/usagePool/PoolHistory/" + poolID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getDistributions(searchQuery: IDistributionSearchQuery): Promise<IDistribution[]> {
        const {
            year,
            distributionType,
            distributionStatus,
            distributionCode,
            cat1,
            cat2,
            description,
            pagination,
            isBackendSearch
        } = searchQuery;
        return new Promise<IDistribution[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/Distributions", {
                    year: year,
                    type: distributionType ? (distributionType.split(" ")).join("") : distributionType,
                    status: distributionStatus,
                    code: distributionCode,
                    cat1: cat1,
                    cat2: cat2,
                    description: description,
                    pagination: pagination,
                    isBackendSearch: isBackendSearch
                })
                .then(response => {
                    const distributionSearchResultItems: IDistribution[] = [];
                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];
                        const distributionSearchResultItem: IDistribution = {
                            distributionID: data.distributionID,
                            distributionCode: data.distributionCode,
                            distributionType: data.distributionType,
                            distributionSubType: data.distributionSubType,
                            distributionStatus: data.distributionStatus,
                            cat1: data.cat1,
                            cat2: data.cat2,
                            distributionDate: data.distributionDate,
                            description: data.description,
                            statementDescription: data.statementDescription,
                            usageFrom: data.usageFrom,
                            usageTo: data.usageTo,
                            claimsFrom: data.claimsFrom,
                            claimsTo: data.claimsTo,
                            distributionPools: data.distributionPools,
                            versionNumber: data.versionNumber,
                            distributionSetTypeGroup: data.distributionSetTypeGroup,
                            distributionRightType: data.distributionRightType,
                            distributionSubjects: data.distributionSubjects,
                            isResetCacheEnabled: data.isResetCacheEnabled,
                            isLivePerformancePortal: data.isLivePerformancePortal,
                            claimable: data.claimable,
                            discountType: data.discountType,
                        };

                        distributionSearchResultItems.push(distributionSearchResultItem);
                    }

                    resolve(distributionSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                })
        });
    }

    public static getAdjustments(searchQuery: IAdjustmentSearchQuery, dataSource: string): Promise<IPaginatedSearchResult<IAdjustment>> {
        const {
            id,
            adjustmentDateFrom,
            adjustmentDateTo,
            user,
            adjustmentCategory,
            adjustmentStatus,
            sourceDistribution,
            adjustmentDistribution,
            sourcePool,
            adjustmentBatchID,
            workNumber,
            productNumber,
            ipNameNumber,
        } = searchQuery;
        return new Promise<IPaginatedSearchResult<IAdjustment>>((resolve, reject) => {
            axiosInstance
                .post("/Search/Adjustments", {
                    id: { value: id, type: 2 },
                    sourceDistribution: { value: sourceDistribution, type: 0 },
                    sourcePool: { value: sourcePool, type: 0 },
                    adjustmentDistribution: { value: adjustmentDistribution, type: 0 },
                    adjustmentDateFrom: { value: adjustmentDateFrom, type: 0 },
                    adjustmentDateTo: { value: adjustmentDateTo, type: 0 },
                    user: { value: user, type: 0 },
                    adjustmentCategory: { value: adjustmentCategory, type: 0 },
                    adjustmentStatus: { value: adjustmentStatus, type: 0 },
                    dataSource: { value: dataSource, type: 0 },
                    pagination: { skip: 0, count: 1000 },
                    adjustmentBatchID: { value: adjustmentBatchID, type: 2 },
                    productNumber: { value: productNumber, type: 0 },
                    WorkNumber: { value: workNumber, type: 2 },
                    IPNumber: { value: ipNameNumber, type: 2 }
                })
                .then(response => {
                    resolve({ results: response.data.results, total: response.data.total });
                })
                .catch(err => {
                    reject(err)
                })
        })
    }

    public static getDistributionsTypes(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Distribution/DistributionTypes/")
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getDistributionSubTypes(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Distribution/DistributionSubTypes/")
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }


    public static getDistribution(distributionId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/Distribution/" + distributionId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getDistributionVersionHistory(distributionID: number): Promise<IVersionHistorySearchResult[]> {
        return new Promise<IVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/DistributionHistory/" + distributionID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getDistributionHistoryVersion(distributionID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/distribution/DistributionHistory/" + distributionID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getPaymentRunVersionHistory(paymentRunID: number): Promise<IPaymentRunVersionHistorySearchResult[]> {
        return new Promise<IPaymentRunVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/PaymentRunHistory/" + paymentRunID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getPaymentRunHistoryVersion(paymentRunID: number, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/paymentRun/PaymentRunHistory/" + paymentRunID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getAdjustmentVersionHistory(adjustmentID: string): Promise<IAdjustmentVersionHistorySearchResult[]> {
        return new Promise<IAdjustmentVersionHistorySearchResult[]>((resolve, reject) => {
            axiosInstance
                .get("Search/AdjustmentHistory/" + adjustmentID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getAdjustmentHistoryVersion(adjustmentID: string, versionNumber: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/adjustment/AdjustmentHistory/" + adjustmentID + '/' + versionNumber)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getClaims(
        searchQuery: IClaimSearchQuery
    ): Promise<IClaimSearchResult[]> {
        const {
            ipiNumber,
            accountNumber,
            claimCode,
            claimStatus,
            fullName
        } = searchQuery;
        return new Promise<IClaimSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/claims", {
                    ipiNumber: {
                        value: ipiNumber,
                        type: 0
                    },
                    accountNumber: {
                        value: accountNumber,
                        type: 0
                    },
                    claimCode: {
                        value: claimCode,
                        type: 0
                    },
                    claimStatus: {
                        value: claimStatus,
                        type: 0
                    },
                    fullName: {
                        value: fullName,
                        type: 0
                    }
                })
                .then(response => {
                    const claimSearchResultItems: IClaimSearchResult[] = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const data = response.data[x];

                        let claimSearchResultItem: IClaimSearchResult = {
                            claimID: data.claimID,
                            claimDate: data.claimDate,
                            claimStatus: data.claimStatus,
                            claimCode: data.claimCode,
                            ipBaseNumber: data.ipBaseNumber,
                            ipName: data.ipName,
                            origin: data.origin,
                            ResolutionDate: data.ResolutionDate,
                            ipNameNumber: data.ipNameNumber
                        }
                        claimSearchResultItems.push(claimSearchResultItem);
                    }

                    resolve(claimSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getClaim(claimID: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/claim/" + claimID)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    public static getAdjustment(adjustmentId: string): Promise<IAdjustment> {
        return new Promise<IAdjustment>((resolve, reject) => {
            axiosInstance
                .get("/Adjustment/" + adjustmentId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getSocietyAffiliation(request: ISocietyAffiliationRequest): Promise<ISocietyAffiliationResult> {
        const body: ISocietyAffiliationRequest = {
            ipBaseNumber: request.ipBaseNumber?.trim() || null,
            ipiNumber: request.ipiNumber || null,
            accountNumber: request.accountNumber?.trim() || null,
            rightType: request.rightType,
            shareSet: request.shareSet?.trim() || null
        };

        return axiosInstance
            .post(
                '/Adjustment/SocietyAffiliation',
                body
            )
            .then(response => response.data);
    }

    public static getIceDistCacheAdditionalInfo(fetchRequest: IIceDistCacheAdditionalInfoRequest): Promise<IIceDistCacheAdditionalInfo> {
        return new Promise<IIceDistCacheAdditionalInfo>((resolve, reject) => {
            axiosInstance
                .post("/work/IceDistCacheAdditionalInfo", fetchRequest)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getTerritoryLineage(codes: string[]): Promise<ITerritoryLineage> {
        if (codes && codes.length == 0) {
            const empty: ITerritoryLineage = {
                includedTerritoryCodes: [],
                excludedTerritoryCodes: [],
            };

            return Promise.resolve(empty);
        }

        return new Promise<ITerritoryLineage>((resolve, reject) => {
            axiosInstance
                .post("/Search/TerritoryLineage", codes)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }


    public static getPaymentRuns(searchQuery: IPaymentRunSearchQuery): Promise<IPaymentRun[]> {
        const {
            paymentRunID,
            type,
            paymentRunDateFrom,
            paymentRunDateTo,
            status,
            distributionCode
        } = searchQuery;
        return new Promise<IPaymentRun[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/PaymentRuns", {
                    paymentRunID: paymentRunID,
                    status: status,
                    type: type,
                    paymentRunDateFrom: paymentRunDateFrom,
                    paymentRunDateTo: paymentRunDateTo,
                    distributionCode: distributionCode
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res.message);
                })
        });
    }

    public static getPaymentRun(paymentRunId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/PaymentRun/" + paymentRunId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getLicenses(searchQuery: IShoppingCartSearchQuery): Promise<IShoppingCart[]> {
        const {
            shoppingCartID,
        } = searchQuery;
        return new Promise<IShoppingCart[]>((resolve, reject) => {
            axiosInstance
                .post("/Search/Licenses", {
                    shoppingCartID: shoppingCartID,
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res.message);
                })
        });
    }

    public static getUsagesLicenses(searchQuery: ILicenseUsageSearchQuery): Promise<{ licenses: ILicenseUsage[] }> {
        const {
            id,
            licensingSystemID,
            customerID,
            venueReference,
            dateFrom,
            dateTo,
            category1,
            category2,
            artistName,
            venueName,
            customerName,
        } = searchQuery;
        return new Promise<{ licenses: ILicenseUsage[] }>((resolve, reject) => {
            axiosInstance
                .post("/Search/LicenseUsage", {
                    id: {
                        value: id,
                        type: 0
                    },
                    licensingSystemID: {
                        value: licensingSystemID,
                        type: 0
                    },
                    customerID: {
                        value: customerID,
                        type: 0
                    },
                    venueReference: {
                        value: venueReference,
                        type: 0
                    },
                    dateFrom: {
                        value: dateFrom ? dayjs.utc(dateFrom).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : '',
                        type: 2
                    },
                    dateTo: {
                        value: dateTo ? dayjs.utc(dateTo).startOf("day").format("YYYY-MM-DDTHH:mm:ss[Z]") : '',
                        type: 2
                    },
                    category1: {
                        value: category1,
                        type: 0
                    },
                    category2: {
                        value: category2,
                        type: 0
                    },
                    customerName: {
                        value: customerName,
                        type: 0
                    },
                    venueName: {
                        value: venueName,
                        type: 0
                    },
                    artistName: {
                        value: artistName,
                        type: 0
                    }
                })
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res.message);
                })
        });
    }

    public static getLicense(licenseId: number): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get("/License/" + licenseId)
                .then(response => {
                    if (response.status === 200) {
                        const result = response.data;
                        resolve(result);
                    }
                    else {
                        throw response;
                    }
                })
                .catch(err => {
                    reject(err);
                })
        })
    }

    public static getLicenseUser(
        searchQuery: ILicenseUserSearchQuery
    ): Promise<ILicenseUserSearchResult[]> {
        const {
            email
        } = searchQuery;
        return new Promise<ILicenseUserSearchResult[]>((resolve, reject) => {
            axiosInstance
                .post("/search/licenseuser", {
                    email: email
                })
                .then(response => {
                    const licenseUserSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const licenseUserSearchResultItem = {
                            name: response.data[x].name,
                            address: response.data[x].address,
                            city: response.data[x].city,
                            postalCode: response.data[x].postalCode,
                            country: response.data[x].country,
                            compositeAddress: response.data[x].compositeAddress,
                            phone: response.data[x].phone,
                            email: response.data[x].email,
                            nameGuid: response.data[x].nameGuid,
                            addressGuid: response.data[x].addressGuid
                        };

                        licenseUserSearchResultItems.push(licenseUserSearchResultItem);
                    }

                    resolve(licenseUserSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }
    static GetAllPackages(userName: string): Promise<any> {
        const url: string = `Package/GetAllPackages/${userName}`;
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .get(url)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                });
        });
    }

    public static getApplicableWorks(
        searchQuery: IApplicableWorkSearchQuery,
    ): Promise<IAgreementWork[]> {
        const {
            workNumber,
            agreementID,
            workName,
            dataSource,
            page,
            pageSize,
            currentUserNameNumber
        } = searchQuery;
        return new Promise<IAgreementWork[]>((resolve, reject) => {
            axiosInstance
                .post("/Agreement/ApplicableWorkSearch", {
                    workNumber: workNumber,
                    agreementID: agreementID,
                    workName: workName,
                    dataSource: dataSource,
                    pagination: null,
                    page: page,
                    pageSize: pageSize,
                    currentUserNameNumber: currentUserNameNumber
                })
                .then(response => {
                    const agreementSearchResultItems = [];

                    for (let x = 0; x < response.data.length; x++) {
                        const agreementSearchResultItem = {
                            agreementWorkID: response.data[x].agreementWorkID,
                            workName: response.data[x].workName,
                            workNumber: response.data[x].workNumber,
                            type: (response.data[x].type),
                            workID: response.data[x].workID,
                            agreementID: response.data[x].agreementID,
                            exclusionUntil: response.data[x].exclusionUntil,
                            excludedUntilDate: response.data[x].excludedUntilDate,
                            recipientWorkNumber: response.data[x].recipientWorkNumber,
                            recipientWorkNumberOwner: response.data[x].recipientWorkNumberOwner,
                            useDefaultRetention: response.data[x].useDefaultRetention,
                            worksRetainedUntil: response.data[x].worksRetainedUntil,
                            workRetentionEndDate: response.data[x].workRetentionEndDate,
                            useDefaultCollection: response.data[x].useDefaultCollection,
                            workCollectionUntil: response.data[x].workCollectionUntil,
                            workCollectionEndDate: response.data[x].workCollectionEndDate,
                            isDeleted: response.data[x].isDeleted
                        };

                        agreementSearchResultItems.push(agreementSearchResultItem);
                    }
                    resolve(agreementSearchResultItems);
                })
                .catch(res => {
                    reject(res);
                });
        })
    }

    public static getWorksFromPackage(
        searchQuery: IWorksFromPackageSearchQuery
    ): Promise<IAgreementWork[]> {
        return new Promise<IAgreementWork[]>((resolve, reject) => {
            axiosInstance
                .post("/agreement/worksFromPackage", searchQuery)
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static getAllEphemerals(): Promise<IEphemerals[]> {
        return new Promise<IEphemerals[]>((resolve, reject) => {
            axiosInstance
                .get("/product/Ephemerals")
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

     public static getAllEphemeralExceptions(): Promise<IEphemeralExceptions[]> {
        return new Promise<IEphemeralExceptions[]>((resolve, reject) => {
            axiosInstance
                .get("/product/EphemeralExceptions")
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

     public static saveEphemeralAndEphemeralExceptions(ephemeralAndEphemeralExceptionsResult: IEphemeralAndEphemeralExceptions): Promise<IEphemeralAndEphemeralExceptions> {
        return new Promise<IEphemeralAndEphemeralExceptions>((resolve, reject) => {
            axiosInstance
                .post("/product/Ephemeral/Save", ephemeralAndEphemeralExceptionsResult)
                .then(response => {
                    resolve(response.data);
                })
                .catch(res => {
                    reject(res);
                });
        });
    }

    public static askGenieChat(content: string, dataSource: string, conversationId?: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post("/Genie/Ask", { content, dataSource, conversationId })
                .then(response => resolve(response.data))
                .catch(res => reject(res));
        });
    }

    public static async askGenieAgent(
        content: string,
        dataSource: string,
        conversationId?: string,
        onEvent?: (event: any) => void
    ): Promise<any> {
        const streamPath = "/Genie/AskAgent";
        const streamUrl = axiosInstance.getUri({ url: streamPath });
        const requestBody = { content, dataSource, conversationId };
        const abortController = new AbortController();
        let completedResponse: any = null;
        let failureMessage: string | undefined;
        const headers = await this.buildStreamRequestHeaders(streamPath, requestBody);

        try {
            await fetchEventSource(streamUrl, {
                method: "POST",
                headers,
                body: JSON.stringify(requestBody),
                signal: abortController.signal,
                openWhenHidden: true,
                onopen: async (response) => {
                    const contentType = response.headers.get("content-type") || "";
                    if (response.ok && contentType.includes(EventStreamContentType)) {
                        return;
                    }

                    const errorText = await response.text();
                    failureMessage = errorText || `Agent request failed with status ${response.status}.`;
                    abortController.abort();
                    throw new Error(failureMessage);
                },
                onmessage: (message) => {
                    const rawData = message?.data || "";
                    if (!rawData) {
                        return;
                    }

                    let data: any = rawData;
                    try {
                        data = JSON.parse(rawData);
                    } catch {
                        // Non-JSON payloads are passed through as raw text.
                    }

                    const eventType = message?.event || "message";
                    const payloadType = data?.type || eventType;
                    onEvent?.({ event: eventType, type: payloadType, data });

                    if (payloadType === "response.completed") {
                        completedResponse = data?.response;
                        abortController.abort();
                        return;
                    }

                    if (payloadType === "response.failed") {
                        failureMessage = data?.response?.error?.message || "Agent request failed.";
                        abortController.abort();
                    }
                },
                onclose: () => {
                    // Treat any premature close as terminal instead of letting fetchEventSource auto-reconnect.
                    if (!completedResponse && !failureMessage) {
                        throw new Error("Agent stream closed unexpectedly.");
                    }
                },
                onerror: (error) => {
                    throw error;
                }
            });
        } catch (error: any) {
            if (error?.name !== "AbortError" || (!completedResponse && !failureMessage)) {
                throw error;
            }
        }

        if (failureMessage) {
            throw new Error(failureMessage);
        }

        if (completedResponse) {
            return this.mapAgentCompletedResponse(completedResponse);
        }

        throw new Error("Agent stream ended without a response.completed event.");
    }

    private static async buildStreamRequestHeaders(url: string, body: any): Promise<Record<string, string>> {
        const response = await axiosInstance.request({
            url,
            method: "post",
            data: body,
            headers: {
                Accept: "text/event-stream",
                "Content-Type": "application/json"
            },
            adapter: async (config: any) => ({
                data: null,
                status: 200,
                statusText: "OK",
                headers: {},
                config
            })
        });

        const sourceHeaders = response?.config?.headers?.toJSON?.() ?? response?.config?.headers ?? {};
        return Object.fromEntries(
            Object.entries(sourceHeaders as Record<string, unknown>)
                .filter(([, value]) => value != null)
                .map(([key, value]) => [key, String(value)])
        ) as Record<string, string>;
    }

    private static mapAgentCompletedResponse(response: any): any {
        const outputItems = Array.isArray(response?.output) ? response.output : [];
        const textParts: string[] = [];
        const tabularData: any[] = [];

        for (const item of outputItems) {
            if (item?.type !== "message" || item?.role !== "assistant") {
                continue;
            }

            const contentItems = Array.isArray(item?.content) ? item.content : [];
            for (const [index, chunk] of contentItems.entries()) {
                if (chunk?.type !== "output_text") {
                    continue;
                }

                const metadata = chunk?.metadata;
                const hasTabularMetadata = Array.isArray(metadata?.columns) && metadata.columns.length > 0 && Array.isArray(metadata?.preview_rows);

                if (hasTabularMetadata) {
                    tabularData.push({
                        statementId: `${item?.id || response?.id || "agent"}-${index}`,
                        columnNames: metadata.columns.map((column: any) => column?.name).filter(Boolean),
                        dataArray: metadata.preview_rows,
                        query: metadata?.sql
                    });
                    continue;
                }

                if (typeof chunk?.text === "string" && chunk.text.trim()) {
                    textParts.push(chunk.text);
                }
            }
        }

        return {
            textContent: textParts.join("\n\n").trim(),
            suggestedQuestions: [],
            tabularData,
            conversationId: response?.conversation_id,
            messageId: response?.id
        };
    }



    public static sendGenieFeedback(dataSource: string, conversationId: string | undefined, messageId: string, rating: "POSITIVE" | "NEGATIVE", comment?: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            axiosInstance
                .post("/Genie/Feedback", { dataSource, conversationId, messageId, rating, comment })
                .then(response => resolve(response.data))
                .catch(res => reject(res));
        });
    }
}
